/*
 * @Author: 张霞 1738830106@qq.com
 * @Date: 2023-08-25 09:34:48
 * @LastEditors: 张霞 1738830106@qq.com
 * @LastEditTime: 2024-09-07 10:30:38
 * @FilePath: /ChileCashy-web/src/lang/en-ES/index.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
export default {
	priority: {
		home: 'Hogar',
		product: 'Producto',
		about: 'Sobre nosotros',
		language: 'idioma',
		reliablePartner: 'Su socio de confianza',
		homeText1: 'Solución todo en uno para cualquier necesidad de transacción personal o comercial',
		details: 'Detalles',
		personal: 'Para uso personal',
		business: 'Para empresas',

		homeText2: '¡Esperamos contar con tu presencia en nosotros!',
		introduction: 'Introducción',
		contact: 'Contact Us',
		address: 'Address',
		started: 'Empezar',

		oproducts: 'Nuestros productos',
		remittanceNeeds: 'Para cualquier necesidad de remesas',
		productText1:
			'Realice transacciones de transferencia en cualquier lugar y en cualquier momento en minutos con tarifas fijas. Brindamos servicios financieros de primer nivel que son intuitivos, rápidos, fáciles de usar y asequibles para todos y empresas, independientemente del tipo y tamaño.',
		exchangeRate: 'Exchange Rate',
		amount: 'Amount',
		exchange: 'Exchange',
		rate: 'Rate',
		domesticTransfer: 'Transferencia Nacional',
		sendMoney: 'Envía dinero sin preocupaciones',
		productText2: 'Puede transferir dinero a cualquier persona en Chile, en cualquier lugar y en cualquier momento, sin preocupaciones. La transacción puede completarse en minutos.',
		remittance: 'Remesas transfronterizas',
		remittanceFP: 'Remesas a familiares y socios',
		productText3: 'Podrás transferir de forma segura y rápida el monto total a tus familiares, amigos y socios comerciales en el extranjero.',
		remittanceAaccounts: 'Remesa a una o varias cuentas',
		productText4: 'Desembolso de fondos para satisfacer todas las necesidades de su negocio, tanto manuales como automáticas, a una o varias cuentas a la vez.',

		aboutText1: 'Construir el futuro de las Finanzas Abiertas con tecnología de vanguardia y la misión de mejorar la inclusión financiera',
		aboutText2:
			'INVERSIONES MAS CREDITO（IMC) es un servicio de remesas en línea que le ayuda a enviar dinero al exterior desde Chile de una manera más fácil, económica y rápida. IMC tiene como objetivo brindar siempre el mejor servicio para que nuestros usuarios envíen dinero al exterior desde Chile. Diseñamos nuestros productos y servicios en función del mercado indonesio para brindar una experiencia de transacción fluida para sus clientes.',
		waw: '¿Quiénes somos?',
		licensedby: 'Licensed by',
		License: 'License No. 12/42/DASP/10',
		destination: 'Choose Destination',
		transactionEasier: 'Transacción más fácil',
		aboutText3: 'Finaliza tu remesa desde tu móvil sin necesidad de realizar pasos extras offline. ',
		fasterSafer: 'Más rápido y más seguro',
		aboutText4: 'El destinatario puede recibir el dinero en minutos. El dinero se reembolsará si la transacción falla.',
		competitivePricing: 'Precios competitivos',
		aboutText5: 'Precio más bajo y tarifa de transferencia fija, para ahorrar su dinero tanto como sea posible con una solución financiera personalizada.',
		customerService: 'Servicio al cliente 24 horas al día, 7 días a la semana',
		aboutText6: 'Te apoyaremos en cualquier momento que nos necesites.',
		aboutText7: 'Ventaja',
		footerTip: 'InversionesX（INVERSIONES MAS CREDITO SpA）- Todos los derechos reservados',
	},
}
